import { supabase } from '@/supabase'; // change path if your file is elsewhere

export async function submitFeedback(name, email, mobile, message, countryCode) {
  const { error } = await supabase.from('feedback').insert([{
    name,
    email,
    mobile,
    country_code: countryCode,
    feedback_text: message,
    feedback_type: 'general', // or make dynamic if you want
    created_at: new Date()    // optional, DB adds by default
  }]);
  if (error) throw error;
}